<template>
  <!--
      作者：kmdshop
      时间：2020-07-10
      描述：插件中心-推三反一-参与人记录
    -->
  <div class="product-add">
    <!--form表单-->
    <div class="d-b-c">
      <el-form size="small" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="form.user_id" placeholder="请输入用户ID"></el-input></el-form-item>
          <el-form-item label="">
           <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
       
      </el-form>
    </div>

    <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
         
          <el-table-column prop="user_id" label="用户" >
            <template slot-scope="scope">
              <div>昵称：{{scope.row.user.nickName}}</div>
              <div>用户ID:{{scope.row.user.user_id}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="total_profits" label="累计获得收益" ></el-table-column>
          <el-table-column prop="total_self" label="累计发起活动" ></el-table-column>
          <el-table-column prop="total_join" label="累计参与活动" ></el-table-column>
        </el-table>
      </div>
       <!--分页-->
       <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

  </div>
</template>

<script>
import PushagainstApi from '@/api/pushagainst.js'
import {mergeTable} from '@/utils/table.js'
export default {
  components: {

  },
  data() {
    return {
      /*是否正在加载*/
      loading:false,

      /*搜索表单对象*/
      form: {
        status:0,
        pushagainst_id:"",//推一反三活动ID
        num:""
      },
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },

  created() {
    this.getData();
  },
  methods: {
 /*查询*/
  onSubmit() {
        this.curPage = 1;
        this.getData();
      },

    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      let Params = self.form;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      PushagainstApi.getUserData(Params,
        true
      )
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;

        })
        .catch(error => {
          self.loading = false;
        });
    },
 /*选择第几页*/
 handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*表格数据格式化*/
    tableFormet(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          bargain_stock: item.bargain_stock,
          bargain_price: item.bargain_price,
          product_attr: item.spec_name,
          product_price:item.product_price,
          bargain_num:item.bargain_num,
          bargain_product_sku_id:item.bargain_product_sku_id,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      curItem.spec_list = spec_list;
      newList.push(curItem);
      return newList;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/pushagainst/userdata/index.vue